import { EndPoints, PasswordPolicy, LogKeys } from './data-response';

export class AppSession {

  private static environmentKey = 'environment';
  private static appPathKey = 'appPath';
  private static amContextKey = 'amContext';
  private static endPointsKey = 'endPoints';
  private static gRecaptchaSiteKey = 'gRecaptchaSiteKey';
  private static passwordPolicy = 'passwordPolicy';
  private static logKeys = 'logKeys';
  private static captchaConfigKey = 'captchaConfig';
  private static expiredKey = 'exp';

  public static getEnvironment() {
    return sessionStorage.getItem(this.environmentKey);
  }
  public static setEnviroment(environment: string) {
    sessionStorage.setItem(this.environmentKey, environment);
  }
  public static deleteEnvironment() {
    sessionStorage.removeItem(this.environmentKey);
  }

  public static getAppPath() {
    return sessionStorage.getItem(this.appPathKey);
  }
  public static setAppPath(appPath: string) {
    sessionStorage.setItem(this.appPathKey, appPath);
  }
  public static deleteAppPath() {
    sessionStorage.removeItem(this.appPathKey);
  }

  public static getAmContext() {
    return sessionStorage.getItem(this.amContextKey);
  }
  public static setAmContext(amContext: string) {
    sessionStorage.setItem(this.amContextKey, amContext);
  }
  public static deleteAmContext() {
    sessionStorage.removeItem(this.amContextKey);
  }

  public static getEndPoints() {
    return JSON.parse(sessionStorage.getItem(this.endPointsKey));
  }
  public static setEndPoints(endPoints: EndPoints) {
    sessionStorage.setItem(this.endPointsKey, JSON.stringify(endPoints));
  }
  public static deleteEndPoints() {
    sessionStorage.removeItem(this.endPointsKey);
  }

  public static getLogKeys() {
    return JSON.parse(sessionStorage.getItem(this.logKeys));
  }
  public static setLogKeys(logKeysVals: LogKeys) {
    sessionStorage.setItem(this.logKeys, JSON.stringify(logKeysVals));
  }
  public static deleteLogKeys() {
    sessionStorage.removeItem(this.logKeys);
  }

  public static deleteAll() {
    sessionStorage.clear();
  }

  public static getGRecaptchaSiteKey() {
    return sessionStorage.getItem(this.gRecaptchaSiteKey);
  }
  public static setGRecaptchaSiteKey(gRecaptchaSiteKey: string) {
    sessionStorage.setItem(this.gRecaptchaSiteKey, gRecaptchaSiteKey);
  }
  public static deleteGRecaptchaSiteKey() {
    sessionStorage.removeItem(this.gRecaptchaSiteKey);
  }

  public static getPasswordPolicy() {
    return JSON.parse(sessionStorage.getItem(this.passwordPolicy));
  }
  public static setPasswordPolicy(passwordPolicy: PasswordPolicy) {
    sessionStorage.setItem(this.passwordPolicy, JSON.stringify(passwordPolicy));
  }
  public static deletePasswordPolicy() {
    sessionStorage.removeItem(this.passwordPolicy);
  }

  public static getCaptchaConfig() {
    return sessionStorage.getItem(this.captchaConfigKey);
  }
  public static setCaptchaConfig(captchaConfig: string) {
    sessionStorage.setItem(this.captchaConfigKey, captchaConfig);
  }
  public static deleteCaptchaConfig() {
    sessionStorage.removeItem(this.captchaConfigKey);
  }
  public static getExpired() {
    return sessionStorage.getItem(this.expiredKey);
  }
  static setExpired(expired: string) {
    sessionStorage.setItem(this.expiredKey, expired);
  }
}
